import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("savora_theme");
    const pref  = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    return saved || pref;
  });

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("savora_theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === "dark" ? "light" : "dark");

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);